import TextInput from './TextInput';
import EmailInput from './EmailInput';
import PasswordInput from './PasswordInput';
import UrlInput from './UrlInput';
import PhoneInput from './PhoneInput';
import TextInputWithMargin from './TextInputWithMargin';

export {
  EmailInput,
  PasswordInput,
  UrlInput,
  PhoneInput,
  TextInputWithMargin,
};

export default TextInput;